import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';

const appointmentSchedule = Loadable(() => import('../../containers/web/appointmentSchedule'));
export default MapTo('vcg/components/soe-home/react/appointment')(appointmentSchedule);
